/**
 * Transcription Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.1.21
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategoryDetailsResponse } from './categoryDetailsResponse';
import { TagResponse } from './tagResponse';

export interface CategoryTagResponse { 
    id?: string;
    type?: CategoryTagResponse.TypeEnum;
    value?: string;
    details?: Array<CategoryDetailsResponse>;
    tags?: Array<TagResponse>;
}
export namespace CategoryTagResponse {
    export type TypeEnum = 'TRANSCRIPTIONS';
    export const TypeEnum = {
        TRANSCRIPTIONS: 'TRANSCRIPTIONS' as TypeEnum
    };
}